
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, DoDont, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  Used to present chunks of information in a concise and scannable way, lists
  help to organize content related to a single topic, grouping together a set of
  items or text options.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <p>{`A list is a series of related items displayed in a single column. The content of each item can be plain text, an external link or a short paragraph. Even if lists can be nested inside of each other (to display sub-sections for example), it's not recommended nesting lists deeper than three levels in order to avoid confusion.`}</p>
    <p>{`Below we'll cover the three list types: `}<a parentName="p" {...{
        "href": "#ordered"
      }}>{`ordered`}</a>{`, `}<a parentName="p" {...{
        "href": "#unordered"
      }}>{`unordered`}</a>{`, `}<a parentName="p" {...{
        "href": "#description-list"
      }}>{`description list`}</a>{`.`}</p>
    <h2 id="ordered">Ordered list</h2>
    <p>{`Ordered lists display a set of items in a specific and logical order.
They are commonly used in step by step instructions.`}</p>
    <p>{`Please note that different list styles can be applied to list items, like numbers, roman numerals or letters.`}</p>
    <p><img parentName="p" {...{
        "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/List/ordered-list-desktop.jpg",
        "alt": "ordered list"
      }}></img></p>
    <DoDont itemDo={{
      title: 'Do',
      image: 'https://inno-ecl.s3.amazonaws.com/media/images/EC/List/ordered-list-desktop-do.jpg',
      alt: '',
      description: 'Show items in the right logical order.'
    }} itemDont={{
      title: "Don't",
      image: 'https://inno-ecl.s3.amazonaws.com/media/images/EC/List/ordered-list-desktop-dont.jpg',
      alt: '',
      description: 'Respect the sequential order and do not use unordered or blank lists.'
    }} mdxType="DoDont" />
    <h2 id="unordered">Unordered list</h2>
    <p>{`Unordered lists are used to show content with the same importance, so the order of the items doesn't matter.`}</p>
    <p>{`Please note that different list styles can be applied to bullets, like disc, circle, square or hyphen.`}</p>
    <p><img parentName="p" {...{
        "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/List/unordered-list-desktop.jpg",
        "alt": "unordered list"
      }}></img></p>
    <h4>{`Guidelines`}</h4>
    <ul>
      <li parentName="ul">{`be sure to organize the items in a logical way`}</li>
      <li parentName="ul">{`start bullet list items with a lowercase letter and blank list items with capital letters`}</li>
      <li parentName="ul">{`limit the numbers of items between 5 to 9`}</li>
    </ul>
    <h2 id="description-list">Description list</h2>
    <p>{`Description lists are lists of terms with their related definition or description, like a glossary or a list of speakers with relative biography.`}</p>
    <p><img parentName="p" {...{
        "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/List/description-list-desktop.jpg",
        "alt": "description list"
      }}></img></p>
    <h4>{`Guidelines`}</h4>
    <ul>
      <li parentName="ul">{`avoid using more than one or two short sentences`}</li>
      <li parentName="ul">{`add a meaningful description or explanation of each term, avoiding active voices`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`use a bullet list when the order of the items is not relevant and to increase scannability and readability`}</li>
      <li parentName="ul">{`use an ordered list when you need to communicate priorities or to show a specific sequence`}</li>
      <li parentName="ul">{`use a description list when the terms in the list require a specific description or explanation`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`do not use for navigation purpose; use `}<Link to="/ec/compositions/navigation-lists/usage/" mdxType="Link">{`navigation lists`}</Link>{` instead`}</li>
      <li parentName="ul">{`do not use to display search results; use `}<Link to="/ec/utilities/stacks/usage/" mdxType="Link">{`stacks`}</Link>{` instead`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;